@if (!loading) {
  <div class="select">
    <select (change)="addInfringementTypeFilter($event)" [value]="SelectedInfringementTypeId">
      <option value="all" selected>All Infringement Types</option>
      @for (type of InfringementTypes; track type) {
        <option [value]="type.Id">
          {{type.Name}}
        </option>
      }
    </select>
  </div>
}
@if (loading) {
  <div class="select">
    <select disabled>
      <option>Loading Infringement Types...</option>
    </select>
  </div>
}

